import React from 'react';
import styled from 'styled-components';

import withi18n from '~/utils/withI18n';
import { getLabelWithDefaultStr } from '~/utils/i18n';
import { FAQ } from '../constants';

type Props = {
  i18n: Object,
};

export default
@withi18n
class Rule extends React.Component<Props> {
  translate = (key, defaultVal) =>
    getLabelWithDefaultStr(`exchange-recharge-${key}`, this.props.i18n, defaultVal);

  render() {
    let { locale } = this.props;
    const faq = FAQ[locale];

    return (
      <Wrapper>
        <div className="content" id="rechargeRule">
          {faq && (
            <React.Fragment>
              <div className="title">{faq.useTitle}</div>
              {faq.useList.map((item, index) => (
                <React.Fragment key={index}>
                  <div className="step">{item.title}</div>
                  <div className="text">{item.text}</div>
                </React.Fragment>
              ))}
              <div className="title">{faq.tipsTitle}</div>
              {faq.tipsList.map((item, index) => (
                <React.Fragment key={index}>
                  <div className="step">{item.title}</div>
                  <div className="text">{item.text}</div>
                </React.Fragment>
              ))}
            </React.Fragment>
          )}

          <div className="title">{`${this.translate('ruleTitle')}:`}</div>
          <div className="text">
            {this.translate(
              'ruleContent',
              '- Rewards from this activity will be split into thirds and distributed to participants over 2 months. The first third of rewards will be distributed after the deposits activity ends, but prior to the start of trading. The second third of rewards will be distributed one month after the deposits activity ends. The last third of rewards will be distributed two months after the deposits activity ends./n- All rewards will be distributed directly to participants’ accounts and will not be confirmed in a further announcement. You will be able to login and see your rewards via Account Center > Wallet > Distribution History./n- All deposits that are made during the activity period will not be able to be withdrawn until the start of trading./n- Binance reserves the right to cancel or amend any Activity or Activity Rules at our sole discretion.'
            )
              .split(/\/n/)
              .map((item, index) => (
                <div key={index}>{item}</div>
              ))}
          </div>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  background: rgba(234, 236, 239, 0.3);
  > .content {
    padding: 10px 16px 24px;
    > .title {
      color: #48515d;
      font-weight: 500;
      font-size: 16px;
      margin-top: 30px;
      margin-bottom: 10px;
    }
    > .step {
      font-size: 14px;
      line-height: 22px;
      color: #212833;
    }
    > .text {
      color: #848e9c;
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 8px;
    }
  }
  @media (min-width: 768px) {
    .content {
      margin: 0 auto;
    }
  }
  @media (min-width: 1260px) {
    .content {
      width: 1260px;
      padding: 10px 0 24px;
    }
  }
`;
